import React, { memo } from 'react';
import { validators } from 'investira.sdk';
import { Stack, CircularProgress, Typography } from 'investira.react.components';
import { useNavigate } from 'react-router-dom';
import EmpresaMetricasInfo from './EmpresaMetricasInfo';
import EmpresaSetores from '../../../pagesPublic/Empresas/Empresa/EmpresaOverview/EmpresaSetores';

const ListEmpresasMetricas = memo(props => {
  const { isLoading, data, message, onClick, metrica, showSectors = true, selectedId } = props;
  const navigate = useNavigate();

  const handleDefaultClick = (pEvent, pItem) => {
    navigate(`/empresas/${pItem.pessoa_id}`);
  };

  const handleClick = onClick || handleDefaultClick;

  return (
    <Stack>
      {!isLoading && !validators.isEmpty(data) && (
        <Stack id="empresas-list" sx={{ px: 0 }} component="ul">
          {data.map(xItem => (
            <EmpresaMetricasInfo
              key={xItem.pessoa_id || crypto.randomUUID()}
              data={xItem}
              onClick={e => handleClick(e, xItem)}
              metrica={metrica}
              component="li"
              showSectors={showSectors}
              sectorsContent={EmpresaSetores}
              selectedId={selectedId}
            />
          ))}
        </Stack>
      )}

      {isLoading && (
        <Stack justifyContent="center" alignItems="center" flexGrow={1} sx={{ py: 2 }}>
          <CircularProgress size={24} />
        </Stack>
      )}

      {!isLoading && validators.isEmpty(data) && (
        <Stack justifyContent="center" alignItems="center" flexGrow={1} sx={{ py: 2 }}>
          <Typography variant="body2" color="textSecondary">
            {message || 'Nenhuma empresa encontrada.'}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
});

export default ListEmpresasMetricas;
